/* eslint-disable  @typescript-eslint/no-explicit-any */
import React from 'react';
import { Grid, IconButton, Typography } from '@mui/material';
import { useHistory } from 'react-router-dom';
import { ReactComponent as OnboardingImg } from '../../../../assets/svg/onboarding-image.svg';
import { ReactComponent as LogoutIcon } from '../../../../assets/svg/logout-icon.svg';
import { Logo } from '../../../Utils/Logo';
import { useIsMobileScreen } from '../../../../libs/utils/utils';

/**
 * Component used to display onboarding layout for partner
 */

export const OnboardingLayout: React.FC<any> = ({children}) => {
  const history = useHistory();
  const isSmallScreen=useIsMobileScreen();

  return (
    <Grid container className={'fx-partner-onboarding-layout'}>
      {!isSmallScreen && <Grid  item xs={4} className={'fx-partner-onboarding-layout-left'}>
         <Grid item container xs={12} className={'fx-partner-onboarding-layout-left-body'}>
           <Grid item >
              <Typography className={'fx-partner-onboarding-layout-left-body-title'}>Welcome to the</Typography>
              <Grid className={'fx-logo-name'}>
                <Logo blueIcon={true}/>
              </Grid>
              <Typography className={'fx-partner-onboarding-layout-left-body-title'}>Referral Program! Your Partner Agreement is confirmed</Typography>
            </Grid>
           <Grid item className={'fx-partner-onboarding-layout-left-body-image'} >
             <OnboardingImg />
           </Grid>
          </Grid>
        <Grid item xs={12} className={'fx-partner-onboarding-layout-left-footer'}>
          <Grid>
            <p>Your Partner Journey Begins Now!</p>
          </Grid>
          <hr />
        </Grid>
      </Grid>}
      <Grid item container justifyContent={!isSmallScreen ? 'space-between' : undefined} xs={!isSmallScreen ? 8 : 12} className={!isSmallScreen ? 'fx-partner-onboarding-layout-right' : ''}>
        <Grid item container xs={!isSmallScreen ? 11 : 12} justifyContent={'center'}>
            {children}
        </Grid>
        {!isSmallScreen && <Grid item>
          <IconButton
            component="a"
            className="fx-profile-icon fx-logout"
            id="logout-button"
            onClick={() => history.push('/logout')}
            title={'Logout'}
            aria-label={'Logout'}
            size="large">
            <LogoutIcon />
          </IconButton>
        </Grid>}
      </Grid>
    </Grid>
  )
}